// extracted by mini-css-extract-plugin
export default {"cardLabel":"update-payment_cardLabel__kfj6Z","cancelButton":"update-payment_cancelButton__VUUez","card":"update-payment_card__7wT2Z"};